var toString = require('../lang/toString');
    /**
     * Replaces hyphens with spaces. (only hyphens between word chars)
     */
    function unhyphenate(str){
        str = toString(str);
        return str.replace(/(\w)(-)(\w)/g, '$1 $3');
    }
    module.exports = unhyphenate;




//////////////////
// WEBPACK FOOTER
// ./~/mout/string/unhyphenate.js
// module id = 1683
// module chunks = 0 1 2